export default {
  //  商品编辑分类
  classify: {
    placeholder: '输入中文或者英文关键词均可检索',
    known_btn: '我已阅读以下须知，确定创建该类商品',
    selected: '已选择：',
    notice: '发布须知：准确选择类目有利于商品曝光，促进转化；若错放类目将会导致流量降权或下架整改。'
  },
  goodsInfo: {
    price_formula_hint: '此建议价格，不包含品类佣金和退货造成的成本',
    pirce_reference: '价格参考公式',
    expected_profit: '期望利润',
    Domestic_freight_cost: '国内运费成本',
    goodsCost: '商品采购金额',
    goodsWeight: '商品重量',
    goodsLong: '体积:长',
    goodsWidth: '外包装宽度',
    goodsHeight: '外包装高度',
    suggested_retail_price: '建议售价',
    mian_img_btn_content: '更换图片',
    Draft_Hint: '请添加商品标题再进行保存',
    batch: '批量',
    hint: '提示',
    img_move_hint: '可拖拽移动图片调整顺序',
    goodsDetailsHint: '商品详情不能为空',
    mainImgHint: '最多只能上传',
    mainImgHint1: '张主图',
    nonblankHint: '名字/属性/商品编码/主图 不能为空,请填写后，重新提交',
    losgNonblankHint: '物流基本信息(商品宽/高/长/重量/类型...)，为空或者不完善,请填写后，重新提交',
    spceNonblankHint: '规格区域内容为空或者不完善,请填写后重新提交',
    spceNonblankHint1: '每个规格下必须填写一个值,请填写后重新提交',
    spceImgHint: '规格图不能为空',
    spce_edit_hint: '新增、修改或删除规格值，会清空数据，是否继续？',
    brandHint: '请选择品牌',
    wordLengthHtin: '最多200 个字符',
    goodsDesc: '请填写商品描述',
    lengthChar: '长度在 0 到 200 个字符',
    titleHint: '请输入标题',
    product_code_hint: '请输入商品编码',
    trademark: '品牌',
    tabbar1: '品类信息',
    tabbar2: '销售信息',
    tabbar3: '售后信息',
    tabbar4: '物流信息',
    tabbar5: '其他信息',
    title1: '商品基本信息',
    title2: '销售信息',
    title3: '商品图文详情',
    tilte4: '物流信息',
    classify: '商品分类:',
    alter: '修改分类',
    headline: '商品标题:',
    property: '商品属性:',
    goodsHint: '请准确填写属性，有利于商品在搜索和推荐中露出，错误填写可能面临商品下架或流量损失!',
    property_plan: '属性填写率:',
    alterinput_placeholder: '请输入',
    product: ' 产品:',
    texture: '材质:',
    production: '产地:',
    goodsImg: '商品轮播图:',
    goodsVideo: '轮播视频:',
    goodsDec: '商品描述:',
    specification: '商品规格:',
    specificationName: '规格名',
    color: '颜色',
    specificationNum: '规格值：',
    placeholde_select: '请选择',
    speci_select_placeholder: '请选择或输入规格',
    add_specificationNum: '添加规格',
    Remove_specificationNum: '移除规格值',
    upload_img_hint: '上传图片只能是 JPG、JPEG、PNG、GIF 格式!',
    upload_img_hint1: '上传图片不能大于2MB!',
    size: '尺寸',
    specificationDet: '规格明细:',
    price: '价格',
    repertory: '库存',
    tatol_repertory: '总库存',
    sale_price: '销售价',
    Specifications_code: '规格编码',
    specification_code: '商品编码',
    cost_price: '成本价',
    specification_img: '规格图片',
    blck: '黑',
    white: '白',
    big: '大',
    center: '中',
    small: '小',
    set_batch: '批量设置',
    market_price: '市场价',
    settlement_amount: '结算金额:',
    inventory_warning: '库存预警',
    purchase_limitation: '限购数量',
    warehouse: '仓库:',
    goodsDetaiImg: '商品详情图:',
    move: '移动',
    PC: 'PC端',
    canImg: '可放',
    numImg: '张图片',
    canInput: '可输入',
    word: '字',
    Picture: '图片',
    World: '文字',
    state: '从PC导入说明',
    PC_hint: '注意：建议卖方单独编辑移动产品说明，以获取更好的布局，否则，默认情况将显示PC描述。（可能看起来不太好）。',
    hint_H1: '1，基本要求：',
    hint_p1: '（1）手机细节的整体大小：图片+文字，图片不超过20个，文字不超过5000个字；',
    hint_p2: '建议：所有图都与宝贝有关',
    hint_H2: '2，图片尺寸要求',
    hint_p3: '（1）建议使用宽度为620~480像素，高度小于960像素',
    hint_p4: '（2）格式：JPG\\JEPG\\GIF\\PNG;',
    hint_p5: '例如：您可以上传宽度480，高度960像素，图片JPG的格式',
    hint_H3: '3，文字要求',
    hint_p6: '（1）每个插入文字不能超过500个单词，标点，特殊字符按照一个单词计算；',
    hint_p7: '（2）请手动输入文字，请勿将文字复制粘贴在页面上，以防乱码；',
    hint_p8: '（3） 以下特殊字符“”，“”，“”，“”，“”，“”将被替换为空。',
    hint_p9: '建议：不要添加太多文字，这样看起来会更清晰。',
    submit: '提交',
    Save_drafts: '保存为草稿',
    Weight: '重量(g):',
    Freight_Setting: '运费模板:',
    Weight_hint: ' 重量不准确可能导致结算延迟。',
    Packing_size: '包装尺寸(cm):',
    Length: '长',
    Width: '宽',
    Height: '高',
    Packing_size_hint: '包装尺寸不准确可能导致结算延迟。',
    Shape: '形状:',
    Hazardous_Cargo: '危险品:',
    yes: '是',
    no: '否',
    Hazardous_Cargo_hint: '是否属于易燃易爆、放射性物质、腐蚀性物质以及其他危险物质。',
    Contains_Battery: '包含电池:',
    Contains_Battery_hint: '货物中是否含有电池',
    Product_Type: '产品类型:',
    Tax_Class: '税率:',
    Other_Information: '其他',
    New_Category: '新类型:',
    Shop_Category: '店铺分类:',
    New_Category_hint: '产品是否可以属于多个分类的店铺',
    Upload: '上传图片',
    UploadImage: '上传图片',
    UploadVideo: '上传视频',
    UploadVideo1: '本地上传',
    tip_video: '请保证视频格式正确(mp4)，且不超过10M',
    tip_img: '请保证图片格式正确(jpg、jpeg、png、gif)',
    tip_video1: '请上传正确的视频格式(mp4)',
    tip_video2: '上传视频大小不能超过10MB哦!',
    tip_video3: '视频上传失败，请重新上传!',
    change_video_btn: '删除',
    video_photo: '视频相册',
    Category: '品类',
    Type: '类型',
    Brand_New: '新品',
    Second_Hand: '二手',
    Product_Name: '标题',
    Short_Description: '描述',
    Specification: '属性',
    please: '请准确填写属性，有利于商品在搜索和推荐中露出，错误填写可能面临商品下架或流量损失!',
    spec_rate: '属性填写率',
    cant_apply: '未找到品牌，点击申请',
    Carousel: '轮播图/视频',
    white_image_name: '白底图',
    white_image_msg: '上传白底图可获得更多的资源位和流量曝光, 建议上传',
    white_image_size_msg: '请上传小于1M的图',
    white_image_width_msg: '请上传宽度大于400px的图',
    white_image_bj_msg: '请选择纯白底色图片',
    white_image_ratio_msg: '请上传长宽1:1的图',
    image_require:'图片要求：宽高相等且大于480px，大小1M内。已上传',
    video_require:'视频要求：仅支持1个不超过10M大小，且格式为MP4,flv,avi,wmv的视频',
    main_iamge:'主图轮播图',
    Detailed_Desc:'详情介绍',
    Preview:'预览',
    Play:'播放',
    Refresh:'刷新',
    Quick_edit:'快捷编辑',
    Add_images:'添加图片',
    Add_videos:'添加视频',
    Add_text:'添加文字',
    image_have:'10张，拖拽可调节顺序',
    most_two:'最多添加两个商品规格，第一个商品规格可添加规格图片',
    Variation_sort:'规格值排序',
    Price_Inventory:'价格和库存',
    please_fill:'请如实填写库存信息，以确保商品可以在承诺发货时间内发出，避免可能的物流违规',
    Inventory_warning:'库存预警值',
    increase:'增',
    decrease:'减',
    Inventory_Adjustment:'库存调整',
    Merchant_Product:'商家商品编码',
    Assoicate_skus:'关联变动前的SKU',
    Is_liquid:'是否液体',
    Is_fragile:'是否易碎',
    does_contain:'是否包含电池',
    Whether:'是否带磁',
    After_sales:'售后服务',
    Add_gift:'新增礼品',
    Number_gifts:'礼品数量',
    Gift_effective_time:'礼品生效时间',
    Settings:'设置',
    Gift_SKU_ID:'礼品SKU ID',
    Gift_Name:'礼品名称',
    Gift_thumbnails:'礼品缩微图',
    Variation:'规格',
    Quantity:'数量',
    Effective_time:'生效时间',
    Operate:'操作',
    Because:'主商品为FBK商品，只能搜索和选择FBK的商品',
    Gift_SKU_Name:'礼品SKU名称',
    Estimated:'预估当前库存',
    Search:'查询',
    Operating_time:'操作时间',
    Edit:'编辑',
    More:'更多',
    Repair:'维修点模版下载',
    Click_view:'点击查看',
    Import_Excel:'导入Excel',
    Exceeding:'超过可选择规格',
    Cannot_enter:'不能输入重复的规格名',
    selling_price:'销售价必须小于市场价',
    selling_must:'销售价必须大于成本价',
    Please_enter:'请输入必填规格',
    Please_required:'请输入sku必填信息',
    Cannot_duplicate:'不能输入重复的规格值',
    Please_variation:'请输入必填规格名',
    Cannot_enter_duplicate:'不能输入重复的规格值',
    Please_ente_variation:'请输入必填规格名',
    Publish_Successful:'上架成功',
    Successfully_Unpublished:'下架成功',
    Please_select:'请最少选择一个已经上架的商品',
    Whether_unpublish:'是否下架商品',
    Successfully_unpublished:'批量下架成功',
    Edit_successfully:'编辑成功',
    Please_correct_format:'请输入正确的数据格式',
    Draft_box:'草稿箱修改成功',
    saved_successfully:'保存草稿成功',
    sales_information:'请输入必填销售信息',
    video_picture:'请输入视频或图片',
    Vat_select:'请选择税率',
    Added_product:'新增商品成功',
    rejection_statement:'请填写拒绝说明',
    Audit_Submitted:'审核提交成功',
    select_category:'请选择分类',
    Whether_product:'是否删除此商品',
    Please_effective:'请检查礼品生效时间和数量',
    product_discribtion:'最多添加30张详情',
    Only_support:'最多只支持选择5项',
    uploaded_avatar:'上传头像图片大小不能超过',
    Please_delete:'请删除已选后再上传',
    uploaded_image:'上传图片必须是JPG/GIF/PNG/BMP 格式',
    Upload_image_cannot:'上传图片大小不能超过 2MB',
    Please_category:'请输入要添加的分类名',
    Please_enter_content:'请输入内容',
    Choose_date_time:'请选择日期',
    Page_view:'页面浏览',
    Uploaded:'已上传',
    Input_text:'输入文字',
    Custom_attributes:"自定义属性",
    Please_type:'请输入类型',
    Cannot_enter_attribute:'不能输入重复的属性值',
    Brand_name:'品牌名称',
    Brand_image:'品牌图片:',
    Brand_authorization_file:'品牌授权文件',
    size_picture:'尺寸: 150px * 50px , 图片小于1M',
    Please_enter_brand:'请输入品牌名称',
    Select_picture:'选择图片',
    Customs_code:'海关编码：',
    Click_customs_code:'点击查看海关编码',
    Customs_Code_Name:'海关编码-名字',
    Customs_code_attribute:'海关编码-属性',
    Type_cargo_transportation:'货物运输类型',
    Cuboid:'长方体',
    Cylindrical:'圆柱',
    Sphere:'球体',
    Irregular:'不规则',
    General_cargo:'普通货物',
    Mobile_phone:'手机/平板/电脑',
    Special_goods:'特殊货品（粉尘、液体、膏状）',
    Electromagnetic:'电磁货品（带电池、充电器、带磁体）',
    HighlySensitiveProducts:'高敏感货物',
    Please_enter_weight:'请输入重量(g)',
    Please_enter_packaging:'请输入商品包装长(cm)',
    Please_enter_Wide:'请输入商品包装宽(cm)',
    Please_enter_Hight:'请输入商品包装高(cm)',
    Videos:'个视频',
    The_list_only:'列表仅展示上传成功的',
    video:'视频',
    Select_picture_video:'选择图片/视频',
    No_data:'暂无数据',
    Start_upload:'开始上传',
    Add:'添加',
    Click_load_more:'点击加载更多',
    Added:'已添加',
    Specification_value:'规格值',
    Please_enter_value:'请输入规格值',
    Please_enter_warehouse:'请输入仓库名称',
    sort_directly:'你可以拖动直接排序',
    Please_custom_attributes:'请输入自定义属性',
    Please_customize_attributes:'请自定义销售属性',
    Commodity_category:'商品类目:',
    Export:'导出',
    Check:'查看',
    Voucher:'优惠卷',
    CouponCode:'核销码',
    Airtime:'话费',
    GeneralProducts:'普通货物',
    Refurbish:'翻新',
    Vat:'税率',
    PackingList: '包装清单: ',
    PlaceholderPackingList: '为了避免产生不必要的售后, 请尽量将产品清单填写完整',
    PleaseEnterPackingList: '请输入包装清单',
    ProductSize: '商品尺码图: ',
    PleaseEnterProductSize: '请选择商品尺码图'
  },
  goodsManage: {
    Mobile: '手机',
    General_Goods: '普通商品',
    Pictures_All: '全部图片',
    Album_User: '用户相册',
    Put_in_Waregouse: '放在仓库',
    Release: '发布',
    inventory_warning_hint: '请确保输入的是大于等于0的整数，且小于库存数',
    price_hint: '请确保大于等于0',
    inventory_hint: `请确保大于等于0且是整数，且不能小于库存预警值`,
    integer_hint: '请确保大于等于0且是整数',
    prices_hint: '请确保是正整数，不能低于成本价且不能大于市场价',
    prices_hint1: '批量设置的价格，必须大于表格中最大的那个成本价且小于市场价',
    costPrice_hint: '请确保是大于等于0的整数，且不能大于销售价',
    market_price_hint: '市场价格不能低于销售价格',
    inventory_warning_hint1: '批量设置的库存值，必须大于表格中最大的那个库存预警值',
    cost_price_input_hint1: '批量设置的成本价，必须小于表格中最小的那个销售价',
    inventory_warning_input_hint1: '批量设置的库存预警，必须小于表格中最小的那个库存值',
    sold_out_hint_content: ' 确认下架当前商品吗？',
    SKU_image: '预览图',
    product_sku_filter_item: '筛选项',
    product_sku_image: 'SKU图',
    Listing_status: '上下架状态',
    The_current_inventory: '当前库存',
    Modify_the_inventory: '修改库存',
    select_sold_out: '批量下架',
    CreationTime: '创建时间',
    Sales: '近三十日销量',
    CumulativeSales: '累积销量',
    Favorites: '收藏数',
    Evaluation: '近30日评价',
    stock: '库存',
    goods_manage: '商品管理:',
    Logistics_type: '物流类型',
    has_sales: '是否有销量',
    goodsNmae: '商品名称',
    Product_platform: '商品SN:',
    max_price: '最大价格',
    min_price: '最小价格',
    goods_SKU_ID: '商品SKU-ID',
    goods_common_ID: '平台商品编号',
    search: '搜索',
    addGoods: '+新增商品',
    // 批量改价
    batchPrice: '批量改价',
    limitPriceChange: '每日仅限2次改价，每次改价执行耗时几十秒到几十分钟不等',
    reminderOfTimesLimit: '您本次不能批量修改价格，因为您今天的修改次数达到了上限。',
    exportProducts: '导出文件',
    allProducts: '所有商品',
    saleProducts: '销售中商品',
    exportTemplate: '导出模板',
    UploadFiles: '上传文件',
    SelectFiles: '选择文件',
    batchPriceCancel: '取消',
    batchPriceSubmit: '提交',
    importedSuccess: '导入成功',
    setType: '批量设置店铺类目',
    alter: '修改',
    goodsInfo: '商品信息',
    present_price: '当前价格',
    putaway: '上架',
    sold_out: '下架',
    set_inventory: ' 批量设置库存:',
    comfirm: '确定',
    close: '取 消',
    comfirm_set: '确定设置',
    alter_repertory: '修改库存',
    detele_hint: '删除提示',
    sold_out_hint: '下架提示',
    Tips_for_listing: '上架提示',
    Tips_for_listing_content: '确认上架当前商品吗？',
    all: '全部',
    on_offer: '在售中',
    SOLD_OUT: '已售罄',
    In_the_warehouse: '仓库中',
    detele_hint1: '确认删除当前商品吗？',
    detele_hint2: '删除后，不能找回',
    sold_out_hint1: '确认下架当前商品吗？',
    storeType: '店铺类目',
    SKU_Detail: 'SKU详情',
    Platform_product: '平台商品编号',
    sku_code: 'SKU ID',
    there_gift: '是否有礼品',
    Price_segment: '价格段',
    Sale_price: '销售价格',
    gift: '礼品',
    Modified_time: '修改时间',
    status: '状态',
    On_sale: '销售中',
    the_shelf: '待上架',
    View_gifts: '查看礼品',
    Bound_gift: '绑定礼品',
    Duplicate: '复制',
    DuplicateErrorMsg: '不能创建相同的商品。',
    select_all: '全选',
    Modify_sales_price: '修改销售价格',
    Already_below_cost: '已高于市场价',
    Serial_number: '序号',
    Category: '所属品类',
    categories: '品类数量',
    application: '申请时间',
    Review_time: '审核时间',
    Pending_review: '待审核',
    passed: '已通过',
    Rejected: '已驳回',
    illustrate: '说明',
    Approval_Status: '审核状态',
    examination_passed: '审核通过',
    Review_rejected: '审核驳回',
    Brand_review: '品牌审核',
    Audit: '审核',
    source: '来源',
    Bound_category: '绑定品类:',
    Authorization_file: '授权文件:',
    reason: '原因:',
    pass_through: '通过',
    Refuse: '拒绝',
    Recently_Used: '最近使用',
    Operator: '操作人',
    successfully_deleted: '删除成功!',
    hint: '提示',
    selected: '已选中',
    information: '绑定礼品信息',
    start_date: '开始日期',
    End_date: '结束日期',
    return_product: '返回商品列表',
    successfully: '提交成功！',
    Submission: '提交失败！',
    Please_required: '请输入必填详情介绍',
    Available_now: '立即上架',
    Not_the_shelf: '保存不上架',
    from_sku_sn: '商家商品编号',
    name: '名称',
    gallery: '空间',
    product_name: '请输入商品名称',
    enter_sku_code: '请输入SKU SN',
    proportion: '宽高比>= 1:3，宽度480px以上，大小1M以内',
    proportion_white: '宽高比>= 1:1，宽度480px以上，大小1M以内',
    Undeleted: "已取消删除",
    Cancel: '取消',
    delete: '确定',
    Notlogged: "尚未登录或登录信息已失效，请登录",
    Theverification: "验证码错误,请重新输入",
    Youdo: "演示环境，没有权限操作",
    Nopermission: "当前操作没有权限",
    Wronguser: "用户名或密码错误",
    Requesterror: "请求错误",
    Unknown: "系统未知错误,请反馈给管理员",
    qualityscore: "信息质量分",
    ProductRating: "商品评分",
    places: "项待优化",
    calculated: "系统算法根据商品信息填写完整性、规范情况所计算的分数，用于衡量商品信息质量高低",
    obtaining: '信息质量分越高, 获取流量的能力越高, 获取流量的渠道也更多',
    Customer: '条评论',
    divided: '信息质量分为',
    immediately: "建议您马上处理",
    optimize: '去优化',
    recommend: '建议优化以下问题',
    Noscore: '暂无评分',
    Optimizing: '优化商品标题的准确性,需要和所在类目相匹配',
    business: "优化完善商详描述的文案和图片",
    filling: '优化完善属性填写率',
    diagram: '请完善轮播图数量',
    improve: '请完善善标题长度',
    uploaded: '商品未上传白底图',
    todolist: '代办',
    Announcements: "通知",
    BusinessDashboard: "生意概览",
    MarkrtingEvents: "营销活动",
    lowercase: "您上传的视频文件名后缀，必须为小写的 .mp4",
    imageVideo: "商品未上传主图视频",
    descriptionVideo: "商品未上传详情视频"
  },
  tagManagement: {
    KiliShop: '自提点',
    Rider: '骑手',
    tagType: '标签类型',
    addTag: '新增标签',
    tag: '标签',
    type: '类型',
    tagContent: '标签内容',
    ReviewsMangment: '评价管理',
    OrderID: '订单编号',
    ListingID: '商品ID',
    keyword: '商品名称',
    Total: '共查询到',
    items: '条数据',
    Only: ',仅展示10条',
    Details: '评价详情',
    OrderInfo: '订单信息',
    ReviewTAG: '评价标签',
    NoData: '暂无数据',
    Reply: '评价回复',
    Reply1: "回复",
    PleaseEnterReply: '请输入你要回复的内容',
    ReviewsHint: '使用评价管理可跟踪买家对您商品的满意度。 您可以查看短期和长期指标，以及详细的反馈条目，包括买方信息和订单编号。 点击“订单编号”以查看卖家平台的“管理订单”部分中的交易详细信息',
    Reviews: "评星",
    ExplainContent: '回复内容',
    content: '内容',
    Feedback_Rating: '用户评价得分',
    all: '全部',
    star: '1 星',
    star1: '2 星',
    star2: '3 星',
    star3: '4 星',
    star4: '5 星',
    Filter: '快速筛选',
    days30: '近7天',
    days90: '近90天',
    days180: '近180天',
    comment_content: '评价内容',
    Is_picture: '是否有图片',
    Is_reply: '是否有回复',
    Whether_content: '主评是否有内容',
    With_Content: '有文字',
    NO_Content: '无',
    No_Comment: '无回复',
    With_Comment: '有回复',
    No_Photos: '无图片',
    With_Photos: '有图片',
    time: '时间'

  },
  businessReport: {
    Details: '详情',
    ProductPage: '商品数据',
    startTime: '开始时间',
    endTime: '结束时间',
    StatisticalTime: '统计时间',
    reducedTime: '对比时间',
    Visitors: '商品访客数',
    ProductsViews: "商品浏览量",
    Totalitemsold: '支付件数',
    CustomersPaid: "支付买家数",
    OrdersPaid: "支付订单数",
    AmountPaid: "支付金额",
    PaymentConversionRate: '支付转化率',
    Favorites: '商品收藏用户数',
    CloseTheTip: '确定关闭？',
    Yesterday: '昨日',
    days7: '近7天',
    days14: '近14天',
    date: '日期',
    hint: '访问商品的用户数，一个用户访问多次 ，只计为1次访客',
    hint1: '商品被浏览的次数，一个用户浏览多次，会计为多次',
    hint2: '商品实际销量',
    hint3: '购买商品的用户数，一个买家购买多次，只计一个买家',
    hint4: '商品被支付的订单数量，如：一个买家购买3次，则计为3个支付订单',
    hint5: '商品被实际支付的总金额',
    hint6: '支付买家数/商品访客数',
    hint7: '截止选中时间，商品累积被用户收藏的次数，一个用户计一次',
    detailTitlteHint: '可通过点击指标来展示或则隐藏指标的曲线图'
  },
  BusinessActivity: {
    ApplyTime: '报名时间',
    activitySetting: '秒杀价降价幅度必须>=',
    activitySetting1: ' 或 降价金额必须>=',
    activitySetting2: '必须>=',
    flashPrice_hint: '请确保输入的是大于等于0的数，且小于售价',
    Withdrawhint: '将此商品撤回, 是否继续?',
    joinHint: '将此商品进行报名, 是否继续?',
    Sold: '销量',
    DateStage: '日期和阶段',
    RefuseCause: '拒绝原因',
    FlashStorage: '秒杀库存',
    FlashPrice: '秒杀价',
    Join: '可报名',
    SearchType: '搜索类型',
    Lastjointime: '报名结束时间',
    ActivityStartTime: '活动开始时间',
    JoinNow: '立即报名',
    JoinRecord: '报名记录',
    JoinTime: '报名时间',
    ActivityTime: '活动时间',
    End: '报名已结束',
    ComingUp: '报名未开始',
    ActivityDescription: '活动介绍',
    JoinRequirements: '报名要求',
    RequirementsForgooods: '对商品的要求',
    Requirements: '活动要求',
    DescriptionOfRequirements: '要求说明',
    ComplianceWithRequirements: '是否符合',
    Cancel: '撤回',
    JoinNows: '重新报名',
    AllMerchandise: '全部商品',
    NonRegistrableItems: '不可报名商品',
    WareHouse_type: '物流类型',
    Search: '搜索',
    ReasonsApply: '不可报名原因',
    JoinAgain: '重新配置',
    SelectedJoinNow: '提交报名',
    CommodityCode: 'Seller Item Id',
    PleaseEnterCode: '请输入编码',
    CommodityCategory: '商品类目',
    PleaseChoose: '请选择',
    TradeName: '商品名称',
    PleaseEnterContent: '请输入内容',
    selectionCannot: '数据选择不能为空，请勾选数据',
    discountPrice: '请设置以下商品的折扣价',
    PriceModification: '不能高于活动最低折扣价',
    GoodsActivityPrices: '商品活动价必须低于',
    Time_limited: '该价格为商品的限制折扣的价格，活动时会读取这个价格',
    belowDiscount: '确认将以下商品批量设置如下折扣吗？',
    GoodsInfo: '商品信息',
    Category: '类目',
    Pricef: '售价',
    ActivityPricef: '活动价',
    Action: '操作',
    Cancelul: '移除',
    Edit: '修改活动价',
    NotBeingable: '你可至“不可报名商品”列表页查看原因',
    meetRequirements: '款商品不符合报名条件',
    ConfiguredReconfigure: '请先移除当前商品已配置的活动，并重新配置活动期间的折扣价',
    followingActivities: '当前商品已配置以下活动',
    ActivityOFPrice: '活动价格',
    ActivityTitle: '活动标题',
    VoidAboveReconfigure: '作废以上活动，并配置当前活动折扣价',
    automaticallyInvalidates: '提交后，系统会自动作废当前商品已配置的活动，并为当前商品重新创建一个限时折扣的活动',
    EventList: '活动列表',
    ActivityTheme: '活动名称',
    GoodsImage: '商品图片',
    OriginalPrice: "原售价",
    FlashSold: '秒杀销量',
    Event_product_details: '活动商品详情',
    Cancel_registration: '撤销报名',
    Rule_of_activity: '活动规则',
    Activity_in_progress: '活动进行中',
    Activity_not_started: '活动未开始',
    activity_ends: '活动结束',
    No_data_hint: '没有活动商品, 未报名秒杀活动',
    No_data_hint1: '立即去报名,获取大量免费流量',
    headerDescription: '"Flash Sales"是 Kilimall 最具特色的限时限量闪购业务，通过限时开团的单品打造“抢”的氛围，为消费提供优质低价位的好货，同时帮助店铺拉动商品流量和成交额，形成店铺日销小高峰, 产生交易后可提升商品的基础权重, 并提高自然流量, 当之无愧的"引流神器"',
    Selected_goods: '选商品',
    to_submit: '待提交',
    submitted: '已提交',
    Tips: '小提示：',
    Tips1: '2.秒杀价降价幅度和降价金额数值越大, 排序越靠前  ',
    Tips2: '3.不需要报名的SKU，库存填0即可',
    Optional_product_list: '可选商品列表',
    Selected_product: '已选商品',
    FlashSoldHint: '还有未提交了商品，是否继续跳过',
    inventory: '商品库存',
    editGoodsInfo: "编辑活动商品信息",
    Batch_settings: '批量设置',
    Batch_settings_prices: "批量设置价格",
    Batch_settings_discounts: "批量设置折扣",
    Batch_settings_inventory: "批量设置库存",
    specification: '商品规格',
    Low_price: '三十天最低售价(不包含秒杀价)',
    Active_inventory_quantity: "SKU活动库存",
    Flash_price: '报名价',
    jump_over: '跳过',
    Sign_up_successfully: '报名成功',
    Sign_up_successfully1: '等待活动开始',
    Sign_up_successfully2: '活动开始，商品上活动位',
    Sign_up_successfully3: '活动期间可能产生大量订单，您可提前做好准备',
    Sign_up_successfully4: '您可在报名记录中及时关注并跟进报名状态',
    View_registration_details: '查看报名详情',
    In_Processing: "待审核",
    Approved: '已通过',
    Refused: '已拒绝',
    Reduce: '减少',
    record_list_hint: '将此记录删除, 是否继续?',
    Prices_prompt: '你设置的秒杀价格过低, 存在亏本风险, 是否确认',
    ProductTypes: "商品类型",
    FlashSalesKili: 'Flash Sales是 Kilimall 最具特色的限时限量闪购业务，通过限时开团的单品打造“抢”的氛围，为消费提供优质低价位的好货，同时帮助店铺拉动商品流量和成交额，形成店铺日销小高峰, 产生交易后可提升商品的基础权重, 并提高自然流量, 当之无愧的"引流神器"',
    DisplayMethod: '活动商品展示方式'
  },
  SponsorPruduct: {
    CreateCampaign: '新增推广计划',
    Wewill: '有推广需求可在此提交申请,运营审核通过后会与你联系安排推广事宜',
    Inreview: '待审核',
    CampaignName: '推广计划',
    SponsoredProducts: '推广商品',
    Budget: '推广费用',
    CampaignStatus: '推广状态',
    Reviewed: '已审核',
    Promoting: '推广中',
    Completed: '结束推广',
    Rejected: '已拒绝',
    Recalled: '已撤回',
    ExpectedSchedule: '意向推广时间',
    Recall: '撤回',
    Approved: '审核通过',
    Topromote: '待开始推广',
    generatereport: '待生成数据报告',
    ViewReport: '查看数据报告',
    ViewPlacement: '查看推广位置',
    Abolished: '已作废',
    CampaignReport: '推广数据报告',
    CampaignPeriod: '推广周期',
    Impressions: '浏览数：',
    Clicks: '点击数：',
    ClickThroughRate: '点击率：',
    AverageCostperClick: '平均点击花费：',
    Opportunities: '推广建议：',
    AdPlacement: '商品推广位置',
    Nodata: '暂无数据',
    RejectedReason: '拒绝原因',
    CampaignName1: '推广计划名称',
    Campaignname: '推广计划名称不能为空',
    Budgetrmb: '推广预算(RMB)',
    budgetamount: '请输入推广预算',
    contribute: '预估将带来',
    visits: '用户访问',
    Budgetcan: '推广预算不能为空',
    Schedule: "意向推广时间：",
    StartDate: '开始日期',
    EndDate: '结束日期',
    expected: '意向推广时间不能为空',
    Selectproduct: '选择商品',
    Reselect: '重新选择',
    beempty: '商品选择不能为空',
    picture: '点击图片选择商品',
    reselect: '点击图片可重新选择商品',
    Submit: '提交审核',
    sponsor: '请选择要推广的商品',
    ProductName: '商品名称',
    aInformations: '商品信息',
    Category: '类目',
    Sales: '销量',
    Inventory: '库存',
    ProductOriginal: '商品原价',
    EventInventory: '活动库存',
    SellerItem: '商品卖家ID',
    Platform: '平台 SKU ID',
    ProductPrice: '商品价格',
    Reasonfor: '不可报名原因',
    selectedproduct: '请为选中的商品设置活动价',
    Enterprice: '请输入价格',
    ComingUp: '未开始',
    Active: '进行中',
    Completeds: '已结束',
    PlatformId: '平台商品ID'
  },
  home: {
    ToDoList: '待办事项',
    Things: '需要你处理的事项',
    Pending: '待催付订单',
    Dispatch: '待发货订单',
    Aftersale: '待处理售后订单',
    Cancellation: '待处理取消订单',
    Messages: '待回复消息',
    Reviews: '待回复评论',
    Violating: '违规下架商品',
    Replenishment: '待补货商品',
    Announcements: '通知',
    More: '查看更多',
    Dashboard: '生意概览',
    Statistics: '统计为最近7天的数据',
    Trend: '销售额走势',
    GMV: '销售额',
    Orders: '订单量',
    Average: '平均订单金额',
    Visitors: '访客数',
    Buyers: '买家数',
    Conversion: '转化率',
    previous: '环比上一周期',
    Promotion: '促销活动',
    EventTime: '活动时间',
    JoinNow: '立即报名',
    new: '最新',
    username: '请输入用户名',
    password: '请输入密码',
    Home: '商城首页',
    Forgotpassword: '忘记密码',
    Openshop: '申请开店',
    Forgotyourpassword: '忘记密码了吗？',
    passwordreset: '请输入您要重置密码的帐户。',
    EmailVerification: '电子邮件验证',
    PhoneVerification: '手机验证',
    Enteryouremail: '输入你的电子邮箱',
    Emailverification: '电子邮件验证码',
    verification: '获取验证码',
    Nextstep: '下一步',
    youremail: '请输入您的电子邮件',
    verificationcode: '请输入您的电子邮件验证码',
    correctformat: '邮件格式错误，正确格式如',
    registered: '我已经注册了',
    SignIn: '登陆',
    Forexample: '例如',
    phonenumber: '请输入您的手机号码',
    smsverification: '请输入您的手机验证码',
    phoneformat: '手机号码格式错误，正确格式如',
    Verificationerror: '验证码错误',
    correctphone: '请输入正确的手机号码',
    Resetpassword: '重置您的密码',
    newpassword: '输入您的新密码',
    Reenter: '重新输入您的密码',
    confirmedpassword: '密码和确认密码不一致',
    Reset: '重置',
    HelpCenter: '帮助中心',
    zhi: '至',
    Wrongformat: '错误的电话格式',
    yourpassword: '请确认您的密码',
    Wrongpassword: '错误的密码格式，正确的格式如',
    icon_1: '最近14天以来,每天客户提交的店铺订单中所有商品总金额',
    icon_2: '最近7天以来,所有消费者提交的店铺订单的商品金额总和',
    icon_3: '最近7天以来,所有消费者提交的店铺订单总和',
    icon_4: '最近7天以来,平均每个订单的商品总金额',
    icon_5: '最近7天以来,浏览过店铺中商品页面的独立用户数,同一个用户不会重复计算',
    icon_6: '最近7天以来,提交过您的店铺订单的独立用户数。同一个用户不会重复计算',
    icon_7: '最近7天以来的店铺访客中,转化为提交店铺订单的买家的比例',
    resend: '重新发送',
    sms: '输入验证码',
    logOut: "退出登录",
    ViewRequirements: '点击查看上传规范',
    toConfirmRestockInvitations:'待确认备货邀请',
    toApplyRestockInvitations :'待申请备货邀请',
    toDispatchRestockApplications :'待发货备货申请',
  },
  afterSale: {
    Buyername: "买家名称",
    OrderNo: "订单编号",
    Orderamount: "订单金额",
    Ordertime: "订单时间",
    Productquantity: "商品数量",
    Contactbuyer: "联系买家",
    Pendingreview: "审核中",
    Processing: "执行中",
    Completed: "完成",
    Cancel: "取消",
    Reason: "原因",
    Returnaddress: "退货地址",
    ReturnInstructions: "退货说明",
    Customervisible: "客户可见",
    Agreereturn: "同意退货",
    Confirmamount: "确认退款金额",
    Confirm: "确认",
    RejectReason: "拒绝原因",
    Rejectstatement: "拒绝说明",
    uploadproofs: "上传凭证",
    ApplicationAmount: "申请金额",
    Adjustamount: "调整金额",
    Instructions: "说明",
    repairCosts: "维修成本",
    ReasonSupport: "支持原因",
    Agreerefund: "同意退货退款",
    updateapplication: "修改申请",
    Refundonly: "不退货直接退款",
    Agreerefund1: "同意退款",
    Appeal: "申诉",
    Adjustrefundamount: "调整退款金额",
    Agreerepair: "同意维修",
    updateexupdate: "调整为换货",
    updatesolutionrefund: '调整为退款退货',
    updatesolutionRepair: "调整为维修",
    agreeexupdate: "同意换货",
    rejectapplication: "拒绝申请",
    Agreewithseller: "同意卖家",
    Goodsreceived: "已收货",
    consignment: "发货",
    Qualityinspectionpassed: "质检通过,同意退款退货",
    QualityPassed: "质检通过",
    Qualityinspectionfailed: "质检未通过,拒绝退款退货",
    Qualityupdate: '质检通过,调整方案',
    Qualityexupdate: "质检通过,同意换货",
    Qualityexupdate1: "质检未通过,拒绝换货",
    Returnrefund: "退款退货",
    completed: "已完成",
    Aremodify: "你确认修改吗?",
    Doconfirm: '你确认收货吗?',
    Servicemonths: "未完结的数量",
    Pleaseresolve: "请及时处理",
    Pendingapproval: "待退款审批",
    Tocustomer: "待客户发货",
    Waitinggoods: "待商家收货",
    Transactionnumber: "交易订单号",
    AvailableTime: "申请时间范围",
    Startdate: "开始日期",
    Enddate: "结束日期",
    ServiceorderNo: "服务订单号",
    Servicetype: "服务类型",
    ApplicationType: "申请服务类型",
    Refund: "退款",
    repair: "维修",
    exupdate: "换货",
    operate: "操作",
    dealWith: "处理",
    View: "查看",
    pendingArbitration: "待仲裁",
    arbitrated: "已仲裁",
    toBeDelivered: "待发货",
    toBeResent: "重寄(发旧货)",
    toBeExchanged: "换货(发新货)",
    pendingReceipt: "待收货",
    pendingReview: "待审核",
    All: "全部",
    Remaining: "还剩",
    Day: "天",
    Hour: "小时",
    minute: "分钟",
    second: "秒",
    ArbitrationSituation: "仲裁/申诉情况",
    ArbitrationStatus: "仲裁状态",
    ProcessingReason: "处理原因",
    ReasonReview: "审核原因",
    Remark: "备注",
    Agreewitbuyer: "同意买家",
    AgreewithSeller: "同意商家",
    ApplicationSituation: "申请情况",
    exupdateItem: "换货商品",
    cargoStatus: "货物状态",
    ApplyType: "申请售后类型",
    ReasonApplication: "申请理由",
    applicationTime: "申请时间",
    WeGoods: "已收到货",
    WeNotGoods: "未收到货",
    GoodsSeller: "商家收货情况",
    ShippingStatus: "发运状态",
    LogisticsAbnormalCancellation:"物流异常取消",
    cargoType: "货物类型",
    typeOfTransport: "运输类型",
    time: "时间",
    shipmentNumber: "物流单号",
    LogisticsCompanyName: "物流公司名称",
    DoorTime: "上门时间",
    ShippersName: "发货人名称",
    ShippersPhone: "发货人电话",
    ShippersAddress: "发货人地址",
    PickupStationName: "自提点名称",
    PickupStationPhone: "自提点电话",
    PickupStationAddress: "自提点地址",
    BuyerContact: "买家联系人",
    BuyerContactInformation: "买家联系方式",
    BuyerAddressInformation: "买家地址信息",
    TheRefund: "如果物流显示已签收，系统将默认已收货",
    ComplaintNotReceived: "未收到货，申诉",
    TimeoutNotHandled: "超时未处理",
    usedGoods: "退回商品",
    newGoods: "新商品",
    selfDelivery: "自寄",
    DoorCollection: "上门取件",
    DeliverStation: "送至自提点",
    GoodsBuyer: "买家退回货物情况",
    ShipperName: "退回人名称",
    ShipperInformation: "退回人联系方式",
    ReturnInformation: "退回人地址信息",
    WaybillNumber: "运单号",
    toBeShipped: "待发运",
    shipped: "已发运",
    CancellationAfterSale: "取消售后",
    BuyersReceipt: "买家收货情况",
    returnContactInformation: "退回人联系方式",
    SellerProcessStatus: "商家处理情况",
    processInformation: "处理信息",
    BuyersConfirmation: "买家确认情况",
    processingTime: "处理时间",
    refundAmount: "退款金额",
    toBeConfirmed: "待确认",
    confirmToAgree: "确认同意",
    ApplyIntervention: "申请仲裁",
    sellerRejectApplication: "商家拒绝售后",
    sellerFailed: "商家质检不通过",
    sellerRefund: "商家调整方案退款退货",
    sellerOnly: "商家调整方案仅退款",
    sellerAdjust: "商家调整方案",
    sellerDeliveryInformation: "商家寄出情况",
    sellerQualityInspection: "商家质检情况",
    QualityInspectionStatus: "质检状态",
    QualityInspectionFailed: "质检未通过",
    QualityAmount: "质检通过,调整金额",
    RefundSituation: "退款情况",
    RequestARefundAmount: "申请退款金额",
    RefundTime: "退款时间",
    createTime: '创建时间', 
    completedTime: '完成时间', 
    RefundStatus: "退款状态",
    RefundChannel: "退款渠道",
    RefundSerialID: "退款流水ID",
    RefundFailed: "退款失败",
    Refunding: "退款中",
    RefundSuccessfully: "退款成功",
    PendingRefund: "待退款",
    pleaseEnter: '请输入',
    search: '查询',
    OrderInformation: '商品订单信息',
    AfterSaleOrderNo: '售后单号',
    OrderCreateTime: '订单创建时间',
    pendingCheckQualtiy: '待质检',
    paymentTime: '订单支付时间',
    PaymentChannel: '支付渠道',
    logisticsType: '物流类型',
    storeId: '店铺ID',
    storeName: '店铺名称',
    orderFinishTime: '订单完成时间',
    agree: '同意',
    Shipping: '补发商品提交',
    category: '品类',
    SendToKilishop: '送到自提点',
    SendToG4S: '自发货G4S',
    county: '县',
    town: '城镇',
    PleaseChooes: '请选择',
    FBKconsignment: '当前订单物流类型为FBK,请确认是否直接发货?',
    ViewLogisticsTrack: '查看物流轨迹',
    Revise: '修改',
    ReviewTheNote: '审核备注',
    ToBeConfirmedByMerchants: '待商家确认',
    MerchantsAgree: '商家同意',
    MerchantsRefuseAfterSalesService: '商家拒绝售后申请',
    MerchantsOfferNewSolutions: '商家提供新方案',
    theSystemAutomaticallyAgrees: '商家超时未操作,自动同意',
    TheUserCancelsApplication: '用户取消售后申请',
    processingState: '处理状态',
    AddADefaultShippingAddress: '请新增收货地址，完成上门取件。',
    noPickupAddress: '当前没有上门取件地址或未选择地址',
    DoorToDoorAddress: "上门取件地址",
    ReceiveAddress: "收货地址",
    setAddress: '设置',
    PleaseSelectReason: '请选择原因',
    PleaseEnterRemarks: '请输入备注',
    PleaseEnterRefundAmount: '请输入退款金额',
    PleaseTrackingNumber: '请输入物流单号',
    PleaseSelectTown: '请选择城镇',
    SelectLogisticsCompany: '请选择物流公司',
    PleaseSelectCounty: '请选择县',
    PleaseEnterContacName: '请输入您的联系人姓名',
    PleaseEnterPhoneNumber: '请输入电话号码',
    PleaseSelectAddress: '请选择一个地址',
    applicationCancelled: "仲裁申请已取消",
    fbk: "FBK",
    gs: "GS",
    ds: "DS",
    storeID: "店铺ID",
    listingID: "Listing ID",
    afterSaleOrderStatus: "售后订单状态",
    goodsReceivedStatus: "交易订单用户是否已收货",
    CompletedTime: "售后订单完成时间",
    inService: "进行中",
    cancelled: "已取消",
    applicationRejectedBySeller: "商家拒绝",
    received: "Received",
    unreceived: "Unreceived",
    rejectApplication:'拒绝售后',
    export:'导出',
    exportTipMsg: '导出请选择申请时间或售后订单完成时间',
    whetherCanResold: "是否可二次销售",
    yesResealable: "是否可二次销售",
    noResealable: "不可二次销售",
    confirmRefundAmount1: "将最大可退金额",
    confirmRefundAmount2: ",调整为",
    confirmRefundAmount3: ",请确认!",
    shippersName: "发件人",
    shippersPhone: "发件人手机号码",
    productNotStockTip:'This product is out of stock, please chane the solution and confirm refund. ',
    opratorId:'仲裁人ID',
    arbitrationResult:'仲裁结果',
    viewTrack:'查看物流',
    aftersaleOrderInformation:'售后详情',
    customerApplication1:'消费者申请',
    customerApplication2:'，退款金额: ',
    aftersaleNo:'订单号',
    experienceNewVersion:'体验新版本',
    aftersaleHistory:'售后日志',
    logistics: '物流',
    payment: '支付',
    back: '返回',
    areYouSuerCancel: '确认是否取消售后申请?',
    theActualNumberReceived: 'The actual number of returned items received does not match the quantity requested. Please adjust the ref und amount accordingly',
    adjustRepair: 'Adjust Repair',
    adjustReturnRefund: 'Adjust Return & Refund',
    repairedToBeResent: 'Repaired, to be resent',
    repairFailedAdjustToReturnRefund: 'Repair falled, adjust to Return & Refund',
    deemedASeriousViolation: 'Deemed a serious violation',
    logisticsInformation: '物流信息',
    orderLog: '订单记录',
    highRisk: `High-risk alert: The user's registered phone number is identical to the phone number on file for the store.`,
    generalRisk: `General risk notice: The user's delivery area (including historical addresses) overlaps with the store's shipping region, same ward.`,
    lowRisk: `Low-risk notice: The user's delivery area (including historical addresses) is in the same city as the store's shipping address.`,
    shopCreateTime: 'Shop create time',
    companyName: '公司名称',
    Settlementcycle: '结算周期',
    storeInfo: '店铺信息',
    userInfo: '用户信息',
    userId: '用户ID',
    phone: 'Phone',
    email: 'Email',
    weeklySettlement: '周结',
    monthlySettlement: '月结',
    TrackNo: '物流单号',
    orderSettlementAmount: 'Order Pending Settlement Amount(Real-time Statistics)',
    pleaseEnterRepairAmount: 'Please enter the repair amount',
  },
  storeAddress: {
    ShippingAddress: '发货地址',
    ReturnAddress: '收货地址',
    default: '默认',
    addAddress: '新增地址',
    editAddress: '编辑地址',
    edit: '编辑',
    delete: '删除',
    save: '保存',
    setAsDefault: '是否默认',
    AreYouSureDefaultAddress: '你确定设置当前地址为默认地址?',
    AreYouSureToDeleteTheAddress: '你确定要删除这个地址吗?',
    storeName: '店铺',
    country: '国家',
    province: '省/洲',
    city: '城市/镇',
    address: '详细地址',
    contactName: '姓名',
    phoneNumber: '手机号码',
    setDefaultAddress: '请新增默认收货地址,如果已有收货地址,请设置默认地址',
  },
  // 财务
  financeInfo: {
    billingPeriod: '账单期数',
    billDownload: '账单下载',
    downloadBill: '下载账单',
    bankreceipt: '银行回单',
    bill_text: '注： 如果您对账单有疑问请',
    customerService: '联系客服',
    weChatService: '或详见',
    shopFAQ: '《账单常见问题FAQ》',
    completeInformation: '请联系客服完善账单周期信息',
    pleaseChoose: '请选择账单期数',
    chooseBill: '请选择期数',
    notqueried: '没有查询到当期的账单'
  },
  storeInfo: {
    shopId: '店铺ID',
    shopName: '店铺名称',
    shopLevel: '店铺等级',
    merchantModel: '店铺模式',
    shopStatus: '店铺状态',
    close: '关闭',
    on: '开启',
    reviewing: '审核中',
    startTime: '创建开始时间',
    endTime: '创建结束时间',
    shopType: '店铺性质',
    contactName: '联系姓名',
    contactPhone: '联系电话',
    email: '联系邮箱',
    whatsapp: 'Whatsapp 账号',
    wechat: '联系人微信',
    lastLoginTime: '上次登录时间',
    shopCreateTime: '店铺创建时间',
    commissionFree: '免佣金到期时间',
    shopLogin: '店铺登录账号',
    shopVacation: '店铺休假状态',
    merchantID: '商户ID',
    merchantType: '商户类型',
    companyName: '公司名称',
    companyAddress: '公司地址',
    addressDetail: '公司详细地址',
    personName: '法人姓名',
    IDType: '法人证件类型',
    IDNo: '法人证件号码',
    validityPeriod: '法人证件有效期',
    Phoneno: '法人联系手机号',
    IDphotofront: '法人证件照-正面',
    IDphotoback: '法人证件照-反面',
    Businesslicense: '营业执照文件',
    BusinessLicenseNumber: '营业执照号码',
    bankPhone: '银行预留手机号',
    Paymentmethod: '结算方式',
    Settlementcycle: '结算周期',
    Settlementcurrency: '结算币种',
    Deposit: '保证金',
    Beneficiarybank: "开户行名称",
    bankCode: '银行代码',
    BankName: '银行名称',
    mpesaName: 'M-PESA注册名称',
    mpesaPhone: 'M-PESA手机号码',
    BankLocation: '开户行地址',
    Accountname: '银行卡账户名称',
    Accountno: '银行卡账号',
    CompanyCountry: '公司注册地国家',
    cancel: '取消',
    shopOperation: '店铺操作',
    closeShop: '关店',
    reopen: '重新开店',
    view: '查看',
    Setas: '设为自营',
    freeze: '冻结',
    unfreeze: '解冻',
    confirm: '确定',
    basicInformation: '基础信息',
    settlementInfo: '结算信息',
    shopInformation: '店铺信息',
    customQuery: '自定义字段查询',
    exprot: '导出',
    pleaseChoose: '请选择',
    unfilled: '未填',
    individual: '个人',
    company: '企业',
    idCard: '身份证',
    passport: '护照',
    BankCcard: '银行卡',
    selectPeriod: '请选择活动结算周期',
    SettlementInformation: ' 结算账号信息',
    StoreType: '店铺类型',
    ReasonClosing: ' 关店原因',
    PleaseInformation: '请选择字段',
    exportNumber: '请输入导出数据条数',
    closedRectification: '关店整顿',
    closeShop_tui: '退店',
    saleableCategory: '可售类目',
    remind: '提示',
    reopenStore: '你确定要重新开启这家店铺吗？',
    reopened: '开店成功',
    shopClosed: '关店成功',
    exportedItems: '导出数据不得超过2000条',
    setStore: '确定将该店铺设置成自营店铺吗？',
    setShopSuccess: '设为自营成功',
    suspend: '冻结', // 冻结 
    thaw: '解冻', // 解冻
    suspendStore: '冻结店铺',
    activateStore: '解冻店铺',
    suspendReason: '冻结原因',
    activatetheStore: '你确定要解冻这家店铺吗？',
    sureSuspendStore: '你确定要冻结这家店铺吗？',
    PendingPaymentsStatement: '保证金代支付声明',
    setBrandStore: '设置官方店',
    setBP: '设为代运营',
    settingBPO: '确认要将此店铺设置为代运营吗？',
    cancalBrandStore: '取消官方店'
  },
  // 计划备货
  restockPlan: {
    addRestockProduct: '添加备货商品',
    affordableQty: '可提供件数',
    arrivedQty: '已到仓件数',
    arrivedValueKSh: '已到仓货值(KSh)',
    arrivedQtyRestock: '已到仓件数 (%邀请备货件数)',
    appliedQtyRestock: '已申请件数 (%邀请备货件数)',
    applyRestock: '创建新备货申请单',
    applicationID: '申请编号',
    applicationTime: '申请时间',
    applyQty: '申请件数',
    applyList: '申请备货表',
    all: '全部',
    arrivalDeadline: '最迟到仓日期',
    approved: '已审核',
    approvedRestockKsh: '已审核货值(KSh)',
    approvedRestockQty: '已审核件数',
    appliedQty: '已申请件数',
    appliedValueKSh: '已申请货值(KSh)',
    affordableValue: '可提供货值(KSh)',
    adminOperate: '管理员操作',
    applyQuantityUnapplied: '按未申请件数全额申请',
    back: '返回',
    createTime: '创建时间',
    category: '品类',
    clear: '清除',
    closed: '已关闭',
    confirm: '确认',
    columns: '显示/隐藏列',
    confirmTitle: '确认后你将无法编辑任何商品及其件数. 你提交的可提供件数有可能会被平台管理员修改. 你是否要确认?',
    confirmPlan: '是的，确认',
    canNotGreater: "不能大于",
    dispatchDeadline: '最迟发货日期',
    dispatchedQty: '已发货件数',
    dispatchedQtyRestock: '已发货件数 (%邀请备货件数)',
    dispatchedValueKSh: '已发货货值(KSh)',
    dispatch: '发货',
    discard: '取消',
    delete: '移除',
    estimateShippingDay: '预估上船日期',
    estShippingDay: '预估上船日期',
    estimatedShippingTip: "预估上船日期指的是您预计将申请的货物装船的日期，如果是空运或陆运，则指您的物流伙伴将货物装载进飞机或卡车的日期。",
    fillReasonInvitation: '请填写您为何拒绝此次邀请备货的原因。',
    gapQty: '相差件数',
    gapValue: '相差货值(KSh)',
    invitationID: '备货邀请编号',
    invitationName: '备货邀请名称',
    id: '编号',
    invitationDeadline: '邀请截止日期',
    inventory: '在库库存',
    inTransit: '在途库存',
    invitationDetails: '备货邀请详情',
    image: '图片',
    kindsOfSKU: 'SKU种数',
    name: '名称',
    netSent: '净出库件数',
    netSent30: '净出库件数(近30天)',
    netSent90: '净出库件数(近90天)',
    noSelectColumn: '您需要选中至少一行',
    no: '不是',
    newAffordableQuantity: '新可提供件数',
    onOff: '关闭/开启',
    operate: '操作',
    pleaseEnter: '请输入',
    pleaseSelect: '请选择',
    planName: '计划名称',
    proposalQty: '建议备货件数',
    productName: '商品名称',
    priceKsh: '单价(KSh)',
    proposal: '建议备货件数',
    proposalValueKSh: '建议备货货值(KSh)',
    proposalValue: '建议备货货值',
    proposalWarehouse: '建议备货仓库',
    pendingConfirm: '待确认',
    productID: '商品编号',
    pendingApproval: '待审核',
    pendingConfirmation: '待确认',
    restockName: '备货邀请名称',
    restockInvitationManagement: '备货邀请管理',
    ratings: '评分',
    restockConfirmList: '确认新增备货列表',
    restockQty: '备货件数',
    restockValueKSh: '备货货值(KSh)',
    remarks: '备注',
    reject: '拒绝',
    relatedRestockApply: '关联的备货申请单',
    rejectTitle: "拒绝指的是您将拒绝备货该邀请中所有的商品.",
    search: '搜索',
    shippingType: '发货方式',
    selectWarehouse: '选择备货仓库',
    selectShippingType: '选择发货方式',
    selectProduct: '选择商品',
    selectCategory: '选择品类',
    submit: '提交',
    submitReject: '提交拒绝该备货邀请',
    summary: '数据概览',
    save: '保存',
    showHideColumns: '显示或隐藏列',
    sellerProposal: '是否卖家自荐？',
    status: '状态',
    storeId: '店铺变好',
    storeName: '店铺名称',
    skuId: 'SKU ID',
    unappliedQty: '未申请件数',
    view: '查看',
    viewRestockInvitation: '查看备货邀请详情',
    warehouse: '仓库',
    whyModify: '为何修改',
    outOneSuccess:'成功操作 1/1 条计划行！',
    noneSelectRows:'没有任意计划行满足此操作条件',
    noDataFound:'暂无数据',
    upperLimit:'上限必须大于下限',
    fillInTheReason: '您需要填写拒绝此邀请备货计划的理由。',
    youFillInTheQuantity: '您必须填写修改可提供数量的理由。',
    fillInTheQuantity: '请填写修改可提供数量的理由。',
    chooseReason: '您需要选择或者填写修改数量的理由。',
    newAffordableRequired: '新的可提供的数量是一个必填项。',
    selectReason: '选择一个理由',
    noAffordable:'请填入可备货数量',
    pleaseInputStockQty:'请为每个申请中的商品填写可备货数量',
    proposalConservative:'建议备货数量太保守了，我能卖得更多',
    proposalAggressive:"建议备货数量太激进了，我担心会滞销",
    proposalMaximum:"建议备货数量超过了我单次最大备货数量",
    proposalSupplier:"建议备货数量小于供应商要求的最小起订量",
    proposalBoxing:"建议备货数量不是单位装箱数量的倍数",
    proposalDontMore:"我不想再销售这个商品了，准备清仓了",
    noneAbove:"不符合以上所有理由",
    tooLateApply:"申请备货超过了本次邀请备货最迟发货日",
    pleaceSelectWarehouse:"请先选择仓库",
    arrived:'已到仓',
    cancelled:'已取消',
    dispatched: '已发货',
    inDraft: '草稿',
    sellerRejected: '卖家已拒绝',
    adminApproved: '管理员已通过',
    adminRejected: '管理员已拒绝',
    equals: '等于',
    contains: '包含',
    mustFillBetween: '您必须填写上限或者下限数值。',
    isEmpty:'为空',
    notEmpty:'不为空',
    selectTheDate:'请选择日期',
    add: '添加',
    Reason: "原因",
    platform: '平台',
    usePlatformLogistics: '使用平台头程物流服务',
    selfDelivery: '跨境卖家自己负责',
    noHeadTrip: '本地卖家自己负责',
    passed: '已通过',
    rejected: '已拒绝',
  }

}